var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupAdd = function SvgGroupAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500-482q29-32 44.5-73t15.5-85-15.5-85-44.5-73q60 8 100 53t40 105-40 105-100 53m220 322v-120q0-36-16-68.5T662-406q51 18 94.5 46.5T800-280v120zm80-280v-80h-80v-80h80v-80h80v80h80v80h-80v80zm-480-40q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47M0-160v-112q0-34 17.5-62.5T64-378q62-31 126-46.5T320-440t130 15.5T576-378q29 15 46.5 43.5T640-272v112zm320-400q33 0 56.5-23.5T400-640t-23.5-56.5T320-720t-56.5 23.5T240-640t23.5 56.5T320-560M80-240h480v-32q0-11-5.5-20T540-306q-54-27-109-40.5T320-360t-111 13.5T100-306q-9 5-14.5 14T80-272zm240 0"
  })));
};
export default SvgGroupAdd;